module.exports = __webpack_public_path__ + "static/media/circle-marker.534470dd.svg";